import BaseTable from "./BaseTable";
import CompanyTable from './tables/company'
import UserTable from './tables/user'

export default function install(Vue, options={}) {
    Vue.component(BaseTable.name, BaseTable)

    Vue.use(CompanyTable);
    Vue.use(UserTable);
};
